<template>
  <div id="app" class="o-body-wrap">
    <main class="c-main" id="main" role="main">
      <complete></complete>
      <promotions></promotions>
    </main>
  </div>
</template>

<script>
import Complete from '@/pages/Complete';
import Promotions from '@/components/Promotions';

export default {
  name: 'appComplete',
  components: {
    complete: Complete,
    promotions: Promotions,
  },
};
</script>

<style lang="scss">
  @import "src/stylesheets/index";
</style>



// WEBPACK FOOTER //
// AppComplete.vue?5c502028